module.exports = __webpack_public_path__ + "img/list-mockup.432df0ae.png";